import aih from './aihRepository'
import assinaturaEletronica from './assinaturaEletronicaRepository'
import assistenciaSocial from './assistenciaSocialRepository'
import atendimentoMedico from './atendimentoMedicoRepository'
import atendimentoRecepcao from './atendimentoRecepcaoRepository'
import atendimentoRetroativo from './atendimentoRetroativoRepository'
import atendimentoTriagem from './atendimentoTriagemRepository'
import cancelamentoEvasao from './cancelamentoEvasaoRepository'
import chamada from './chamadaRepository'
import classificacaoRisco from './classificacaoRiscoRepository'
import enfermagem from './enfermagemRepository'
import exameImagem from './exameImagemRepository'
import fechamentoFaa from './fechamentoFaaRepository'
import fechamentoFaaMassa from './fechamentoFaaMassaRepository'
import fila from './filaRepository'
import filaAtendimento from './filaAtendimentoRepository'
import impressao from './impressaoRepository'
import impressaoFaaEletronica from './impressaoFaaEletronicaRepository'
import laudoExame from './pedidoExameLaudoRepository'
import observacao from './pacienteObservacaoRepository'
import pacienteBusca from './pacienteBuscaRepository'
import parametrizacao from './parametrizacaoRepository'
import plantao from './plantaoRepository'
import reaberturaAtendimento from './reaberturaAtendimentoRepository'
import regularizacaoCadastro from './regularizacaoCadastroRepository'
import relatorioAtendimento from './relatorioAtendimentoRepository'
import relatorioClassificacaoRisco from './relatorioClassificacaoRiscoRepository'
import relatorioDocumentoNaoAssinado from './relatorioDocumentoNaoAssinadoRepository'
import relatorioExameImagem from './relatorioExameImagemRepository'
import relatorioPlantao from './relatorioPlantaoRepository'
import relatorioPrescricaoInterna from './relatorioPrescricaoInternaRepository'
import relatorioProducaoMedico from './relatorioProducaoMedicoRepository'
import relatorioQuantitativoProducao from './relatorioQuantitativoProducaoRepository'

export default baseUrl => {
    baseUrl = `${baseUrl}/pronto-atendimento`

    return {
        aih: aih(baseUrl),
        assinaturaEletronica: assinaturaEletronica(baseUrl),
        assistenciaSocial: assistenciaSocial(baseUrl),
        atendimentoMedico: atendimentoMedico(baseUrl),
        atendimentoRecepcao: atendimentoRecepcao(baseUrl),
        atendimentoRetroativo: atendimentoRetroativo(baseUrl),
        atendimentoTriagem: atendimentoTriagem(baseUrl),
        cancelamentoEvasao: cancelamentoEvasao(baseUrl),
        chamada: chamada(baseUrl),
        classificacaoRisco: classificacaoRisco(baseUrl),
        enfermagem: enfermagem(baseUrl),
        exameImagem: exameImagem(baseUrl),
        fechamentoFaa: fechamentoFaa(baseUrl),
        fechamentoFaaMassa: fechamentoFaaMassa(baseUrl),
        fila: fila(baseUrl),
        filaAtendimento: filaAtendimento(baseUrl),
        impressao: impressao(baseUrl),
        impressaoFaaEletronica: impressaoFaaEletronica(baseUrl),
        laudoExame: laudoExame(baseUrl),
        observacao: observacao(baseUrl),
        pacienteBusca: pacienteBusca(baseUrl),
        parametrizacao: parametrizacao(baseUrl),
        plantao: plantao(baseUrl),
        reaberturaAtendimento: reaberturaAtendimento(baseUrl),
        regularizacaoCadastro: regularizacaoCadastro(baseUrl),
        relatorioAtendimento: relatorioAtendimento(baseUrl),
        relatorioClassificacaoRisco: relatorioClassificacaoRisco(baseUrl),
        relatorioDocumentoNaoAssinado: relatorioDocumentoNaoAssinado(baseUrl),
        relatorioExameImagem: relatorioExameImagem(baseUrl),
        relatorioPlantao: relatorioPlantao(baseUrl),
        relatorioPrescricaoInterna: relatorioPrescricaoInterna(baseUrl),
        relatorioProducaoMedico: relatorioProducaoMedico(baseUrl),
        relatorioQuantitativoProducao: relatorioQuantitativoProducao(baseUrl),
    }
}
